<template>
  <div class="">

    <div v-if="$can(abilities.EDIT_FORMALITIES_PARAMETERS)" class="d-flex justify-content-end">
      <Button @click.prevent="addTable" type="button" btn-class="btn-sm btn-primary me-2" btn-text="Ajouter un tableau" size="7px 30px"></Button>
    </div>

    <div v-if="model.length" class="row">
      <div v-for="(table, key) in model" :key="key" class="table-responsive py-5 px-5">

        <div class="d-flex w-50 mb-5 justify-content-between align-items-center">
          <input type="text" placeholder="Entrez ici le nom du tableau" class="form-control form-control-solid text-center"  v-model="table.name" required/>
          <i v-if="$can(abilities.EDIT_FORMALITIES_PARAMETERS)" class="fas fa-trash fs-1 ms-4 cursor-pointer text-danger" @click.prevent="deleteTable(key)"></i>
        </div>

        <table class="formality table-rounded table table-bordered">
          <thead>
          <tr class="fw-bold fs-6 text-gray-800">
            <th v-for="(column, key) in table.columns" :key="key" class="text-center min-w-200px px-6 position-relative">
<!--              <input type="text" placeholder="Entrez ici le nom de la colonne" class="form-control form-control-solid text-center"  v-model="column.name" required/>-->
              <textarea v-model="column.name" class="form-control form-control-solid text-center px-6" required></textarea>
              <button
                  class="position-absolute btn btn-light border_button_light py-1 px-3 table_button"
                  type="button"
                  style="bottom: -12px; right: -15px; z-index: 1;"
                  @click="addColumn(table, key)"
                  title="Ajouter une colonne"
                  v-if="$can(abilities.EDIT_FORMALITIES_PARAMETERS)"
              >
                <i class="fas fa-plus text-primary p-0"></i>
              </button>

              <button
                  class="position-absolute btn btn-light border_button_light py-1 px-3 table_button"
                  type="button"
                  style="top: -12px; right: -15px; z-index: 1;"
                  @click="deleteColumn(table, key)"
                  title="Supprimer cette colonne"
                  v-if="$can(abilities.EDIT_FORMALITIES_PARAMETERS)"
              >
                <i class="fas fa-trash text-danger p-0"></i>
              </button>
            </th>
          </tr>
          </thead>
          <tbody>
          </tbody>
        </table>
      </div>
    </div>
    <div v-else>
      <div class="h-350px d-flex justify-content-center align-items-center" >
        <div class=" text-center ">
          <div class="pt-8 ">
            <Img filename="empty.png" alt=""
                 class="mw-100 h-125px h-sm-175px" />
          </div>
          <h2 class="fs-2x fw-bolder mb-0">{{ $t('projects.table.addTable') }}</h2>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-end">
      <Button v-if="$can(abilities.EDIT_FORMALITIES_PARAMETERS)" @click.prevent="addTable" type="button" btn-class="btn-sm btn-primary me-2" btn-text="Ajouter un tableau" size="7px 30px"></Button>
    </div>
  </div>
</template>

<script setup>
  import Button from "@/components/Button.vue";
  import Input from "@/components/Input.vue";
  import Img from "@/components/Img.vue";
  import abilities from "@/composables/abilities";

  const model = defineModel()

  function addTable() {
    model.value.push({
      name: '',
      columns: [
        {
          name: 'N°'
        }
      ]
    })
    window.scrollTo(0, document.body.scrollHeight);
  }

  function addColumn(table, key) {
    table.columns.splice(key + 1, 0, {
      name: ''
    })
  }

  function deleteColumn(table, key) {
    if(table.columns.length > 1) {
      table.columns = table.columns.filter((x,y) => y !== key)
    }
  }

  function deleteTable(key) {
    model.value = model.value.filter((x,y) => y !== key)
  }
</script>

<style scoped>
.formality.table {
  --bs-table-color: #212529;
  --bs-table-bg: transparent;
  --bs-table-border-color: #dee2e6;
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: #212529;
  --bs-table-striped-bg: rgba(0, 0, 0, 0.05);
  --bs-table-active-color: #212529;
  --bs-table-active-bg: rgba(0, 0, 0, 0.1);
  --bs-table-hover-color: #212529;
  --bs-table-hover-bg: rgba(0, 0, 0, 0.075);
  width: 100%;
  margin-bottom: 1rem;
  color: var(--bs-table-color);
  vertical-align: top;
  border-color: var(--bs-table-border-color);
  border-collapse: collapse;
}

.border_button_light {
  border: 1px solid #dee2e6 !important;
}

.formality.table-bordered > :not(caption) > * {
  border-width: 1px 1px;
  border-style: solid;
  border-color: var(--bs-table-border-color);
}

.formality.table-bordered th,
.formality.table-bordered td {
  border: 1px solid #dee2e6;
}

.formality.table-bordered tbody tr:last-child td {
  border-bottom: 1px solid var(--bs-table-border-color) !important;
}

.table_button {
  opacity: 0;
}

.formality:hover .table_button{
  opacity: 1;
}

.table_button:hover {
  opacity: 1 !important;
}

</style>